module.exports = __webpack_public_path__ + "img/certificate_ogr_620352716_00.a39ee1fa.png";